import axios from 'axios';
import { urlCallLog } from '../utils';

export const apiCallLog = axios.create({
    baseURL: `${urlCallLog}`
});